import type { ActivityModule } from '../../core/activity';
import { mountShare } from './ui';
import levelsData from './levels.json';
import './style.css';

export const share: ActivityModule = {
  id: 'share',
  title: 'Dividir doces',
  description: 'Distribua os doces igualmente entre as crianças. O que sobrar vai pra cesta.',
  ageMin: 5,
  ageMax: 9,
  difficulty: 3,
  iconPath: 'assets/gcompris-AGPL/share/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountShare,
};
